import { useState } from 'react';
import { setModelsModalState, useModelsModalState } from '../../../../../store/state';
import { useAsyncEffect } from 'ahooks';
import { v4 } from 'uuid';
import { request } from '@shakkerai/services';
import { innerMoreType, modelTypeMap, quickModelShowType } from '../../../../../constants';
import { useTempState } from '@starflow/app/store';

export const pageSize = 8; // 8 是目前交互稿中最大屏一排展示个数，一排展示个数根据屏幕宽度自适应增减个数展示

export const useCateListFetch = (menuPath, modelType) => {
  const [loading, setLoading] = useState(false);
  const catesModels = useModelsModalState('catesModels');
  const baseTypes = useModelsModalState('baseTypes');
  const globalMode = useTempState('globalMode');

  const fetchCollect = async ({ type, label, code, data, ...params }) => {
    try {
      const res = await request('/api/canva/model/collection', params);
      if (res.code === 0) {
        return {
          id: code,
          type: innerMoreType.collect,
          list: res.data.data,
          total: res.data.total,
          title: label,
          fetched: true,
        };
      } else {
        return {
          fetched: true,
        };
      }
    } catch (err) {
      console.log(err);
      return {
        fetched: true,
      };
    }
  };
  const fetchList = async ({ type, label, code, data, ...params }) => {
    try {
      const res = await request('/api/www/model/tool/baseSearch', params);
      if (res.code === 0) {
        return {
          id: code,
          type: innerMoreType.children,
          list: res.data.data,
          total: res.data.total,
          title: label,
          fetched: true,
          page: params.page,
          requestId: params.requestId,
        };
      } else {
        console.log('接口异常');
        return {
          fetched: true,
        };
      }
    } catch (err) {
      console.log(err);
      return {
        fetched: true,
      };
    }
  };

  // 列表数据是根据是否有合集以及children来共同决定
  useAsyncEffect(async () => {
    if (!menuPath) return;
    let configList = menuPath.menu.featureCates ?? [];
    setLoading(true);

    const headFetchList = configList.slice(0, 3).map((item) => () => {
      if (item.type === quickModelShowType.collection) {
        return fetchCollect({
          page: 1,
          pageSize,
          collectionId: item.code,
          requestId: v4(),
          ...item,
        });
      }
      if (item.type === quickModelShowType.tagCode) {
        return fetchList({
          modelType: modelTypeMap[modelType],
          page: 1,
          pageSize,
          requestId: v4(),
          baseTypes: globalMode === 'pro' ? baseTypes : ['19'],
          tagCode: item.code,
          ...item,
        });
      }
      if (item.type === quickModelShowType.appendTagCode) {
        return fetchList({
          modelType: modelTypeMap[modelType],
          page: 1,
          pageSize: 30,
          requestId: v4(),
          baseTypes: globalMode === 'pro' ? baseTypes : ['19'],
          tagCode: item.code,
          ...item,
        });
      }
    });
    const results = await Promise.all(headFetchList.map((fn) => fn()));
    configList = configList.map((config) => {
      return {
        ...config,
        data: (results ?? []).find((re) => re?.id === config.code) ?? {},
      };
    });
    setModelsModalState({
      catesModels: {
        ...catesModels,
        [`${menuPath.level}-${menuPath.menu.code}`]: configList, // key这样拼接是防code重复
      },
    });
    setLoading(false);
  }, [menuPath]);
  return { loading, fetchList, fetchCollect };
};
